import React from 'react';
import img3 from '../assets/images/img_3.png';
const About= () => {
    return (
        <section className="bg-primary hiro-section" id="about">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 d-flex flex-column justify-content-center wow fadeInUp">
                        <h2 className="section-title mb-3">Need a Laugh and a Staff? Wala Work’s Got Your Back!</h2>
                        <p className="section-text-ct">
                        Is your business feeling like a sinking ship with a skeleton crew? Fear not, because Wala Work is here to rescue you faster than a superhero in a blockbuster movie! 🌟                        </p>
                    </div>
                    <div className="col-md-6 wow fadeInUp">
                        <img src={img3} className="w-100 mb-5" alt="Digital Product Design" />
                        <p className="section-text-light">
                            
                                <li >Super-Speedy Staffing</li>
                                <li>Quality Over Quantity</li>
                                <li >Laughs Guaranteed</li>
                                <li >Join the Wala Work Revolution Today</li>
                           
                        </p>
                        <button className="hiro-btn-outline">VIEW MORE</button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
